import { Component, OnInit, Input, Output, forwardRef, EventEmitter, ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'dhs-score',
    templateUrl: './score.component.html',
    styleUrls: ['./score.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScoreComponent),
            multi: true
        }],
    standalone: false
})
export class ScoreComponent implements ControlValueAccessor, OnInit {
  propagateChange = (_: any) => { };
  @Input('value') _value: any;
  @Input() current_action;
  @Input() scoreField: any;
  @Input() scoreData: any;
  @Input() radio_support: boolean;
  @Input() isScoreData: boolean;
  @Input() totalScoreDisable: boolean;
  @Input() question: any;
  scoreForm: FormGroup;
  riskData = [];
  label: any = [];
  risk = '';
  scoreField_value = [];
  control: FormArray;
  sum: any = 0;
  scoreArray: any;
  finalscore: any;
  innerObj = [];
  className: any;
  isNumericVal: boolean = false;
  isSet: boolean = false;
  isSetArray: boolean = false;

  constructor(private fb: FormBuilder,
    private elementRef: ElementRef) {
  }
  ngOnInit() {
    this.scoreForm = this.fb.group({
      rows: this.fb.array([])
    });
    this.riskData = this.scoreData;
    if (this.scoreField && this.scoreField.length > 0) {
      for (let i = 0; i < this.scoreField.length; i++) {
        this.label.push(this.scoreField[i].scoreLabel);
        if (!this.value) {
          this.addRow(this.scoreField[i].scoreLabel);
        }
        if (this.scoreField[i].is_numeric_value)
          this.isNumericVal = true;//for check numeric value col exist
      }
    }
    if (this.value) {
      let data = JSON.parse(this.value);
      this.innerObj = data.scoreField
    }
  }

  ngAfterOnInit() {
    this.control = this.scoreForm.get('rows') as FormArray;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }
  writeValue(value) {
    if (value) {
      this.value = value;
      this.setvalueForUpdate(this.value);
    }
    this.propagateChange(value);
  }
  setvalueForUpdate(value) {
    for (let i = 0; i < this.scoreField.length; i++) {
      let valueData = JSON.parse(value)
      if (valueData && valueData.scoreField) {
        this.sum = valueData.scoreSum;
        this.risk = valueData.riskLevel;
        if (valueData.scoreField[i] && valueData.scoreField[i].score != undefined)
          this.addRow(valueData, valueData.scoreField[i].score, valueData.scoreField[i].name, valueData.scoreSum, valueData.scoreField[i].numeric_value, valueData.scoreField[i].is_multi_value);
        if (valueData.scoreField[i] == null) {
          this.addRow(valueData, "", "", valueData.scoreSum, "");
        }
      }
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  //on numeric value change
  valueChange(item, row, index) {
    this.isSet = false;
    let score = item.target.value;
    const myForm = (this.scoreForm.get('rows') as FormArray).at(index);
    let val = this.scoreField[index];
    for (let option of val.scoreFieldData) {
      this.scoreField_value = [];
      if (option.data.includes('-') && !this.isSet) {
        let arr = option.data.split('-');
        if (Number(score) >= Number(arr[0]) && Number(score) <= Number(arr[1])) {
          this.setControlAfterMatch(item, myForm, option, val, index);
        } else {
          this.resetControl(myForm);
        }
      }
      else if (option.data.includes('<') && !option.data.includes('=') && !this.isSet) {
        let arr = option.data.split('<');
        let elem = arr[0] == '' ? 'first' : 'zero';
        let condition = elem == 'first' ? Number(score) < Number(arr[1]) : Number(arr[0]) < Number(score)
        if (condition) {
          this.setControlAfterMatch(item, myForm, option, val, index);
        } else {
          this.resetControl(myForm);
        }
      }
      else if (option.data.includes('<=') && !this.isSet) {
        let arr = option.data.split('<=');
        let elem = arr[0] == '' ? 'first' : 'zero';
        let condition = elem == 'first' ? Number(score) <= Number(arr[1]) : Number(arr[0] <= Number(score))
        if (condition) {
          this.setControlAfterMatch(item, myForm, option, val, index);
        } else {
          this.resetControl(myForm);
        }
      }
      else if (option.data.includes('>') && !option.data.includes('=') && !this.isSet) {
        let arr = option.data.split('>');
        let elem = arr[0] == '' ? 'first' : 'zero';
        let condition = elem == 'first' ? Number(score) > Number(arr[1]) : Number(arr[0]) > Number(score)
        if (condition) {
          this.setControlAfterMatch(item, myForm, option, val, index);
        } else {
          this.resetControl(myForm);
        }
      }
      else if (option.data.includes('>=') && !this.isSet) {
        let arr = option.data.split('>=');
        let elem = arr[0] == '' ? 'first' : 'zero';
        let condition = elem == 'first' ? Number(score) >= Number(arr[1]) : Number(arr[0]) >= Number(score)
        if (condition) {
          this.setControlAfterMatch(item, myForm, option, val, index);
        } else {
          this.resetControl(myForm);
        }
      }
      else if (score == option.data && !this.isSet) {
        this.setControlAfterMatch(item, myForm, option, val, index);
      }
      else {
        if (!this.isSet)
          this.resetControl(myForm);
      }
    }
    this.autosum();
  }
  setControlAfterMatch(item, myForm, option, val, index) {
    this.finalscore = option.score;
    this.scoreField_value.push({ "scoreLabel": val.scoreLabel, 'name': option.data, 'score': option.score, "numeric_value": item.target.value });
    var columns = this.scoreField_value[0];
    this.innerObj[index] = columns;
    this.scoreArray = this.innerObj;
    if (myForm) {
      myForm.get('score').setValue(option.data);
      myForm.get('scoreField').setValue(this.finalscore);
      this.isSet = true;
    }
  }
  resetControl(myForm) {
    if (myForm && !this.isSet) {
      myForm.get('score').setValue("");
      myForm.get('scoreField').setValue("");
    }
  }

  onChange(item, row, index) {
    this.isSetArray = false;
    let score = item.target.id;
    if (score == "") {
      score = item.target.value;
    }
    const myForm = (this.scoreForm.get('rows') as FormArray).at(index);
    let val = this.scoreField[index];
    for (let option of val.scoreFieldData) {
      this.scoreField_value = [];
      if (score == option.data) {
        this.finalscore = option.score;
        this.scoreField_value.push({ "scoreLabel": val.scoreLabel, 'name': option.data, 'score': option.score });
        var columns = this.scoreField_value[0];
        // this.scoreField_value.forEach(res => {
        //   if (res.scoreLabel == val.scoreLabel && res.name != score) {
        //     this.scoreField_value.splice(this.scoreField_value.indexOf(res), 1);
        //   }
        // });
        this.innerObj[index] = columns;
        this.scoreArray = this.innerObj;
        this.isSetArray = true;
      }
    }
    //check when deselect score option
    if (!this.isSetArray) {
      this.finalscore = "";
      this.scoreField_value.push({ "scoreLabel": val.scoreLabel, 'name': "", 'score': "" });
      var columns = this.scoreField_value[0];
      this.innerObj[index] = columns;
      this.scoreArray = this.innerObj;
    }
    if (myForm)
      myForm.get('scoreField').setValue(this.finalscore);
    // if (this.radio_support)
    this.autosum();
  }

  onMultiDropdownChange(selectedItems: any[], index: number) {
    console.log('Selected items from multi-dropdown:', selectedItems);
    const myForm = (this.scoreForm.get('rows') as FormArray).at(index);
    const val = this.scoreField[index];

    // Find all scores from val.scoreFieldData for selected items
    const selectedScores = [];
    const selectedNames = [];
    if (Array.isArray(selectedItems)) {
      selectedItems.forEach(item => {
        // item can be {id, text} or just a value
        const found = val.scoreFieldData.find(opt => opt.data == item);
        if (found) {
          selectedScores.push(Number(found.score));
          selectedNames.push(found.data);
        }
      });
    }

    // Perform calculation based on calculation_type
    let calculatedScore = 0;
    switch (val.calculation_type) {
      case 'addition':
        calculatedScore = selectedScores.reduce((a, b) => a + b, 0);
        break;
      case 'multiplication':
        calculatedScore = selectedScores.reduce((a, b) => a * b, selectedScores.length ? 1 : 0);
        break;
      case 'min':
        calculatedScore = selectedScores.length ? Math.min(...selectedScores) : 0;
        break;
      case 'max':
        calculatedScore = selectedScores.length ? Math.max(...selectedScores) : 0;
        break;
      case 'avg':
      case 'mean':
        calculatedScore = selectedScores.length ? (selectedScores.reduce((a, b) => a + b, 0) / selectedScores.length) : 0;
        break;
      case 'custom':
        if (val.formula && val.formula.trim() !== '') {
          let formula = val.formula;
          const sum = selectedScores.reduce((a, b) => a + b, 0);
          const product = selectedScores.reduce((a, b) => a * b, selectedScores.length ? 1 : 0);
          const min = selectedScores.length ? Math.min(...selectedScores) : 0;
          const max = selectedScores.length ? Math.max(...selectedScores) : 0;
          const avg = selectedScores.length ? (sum / selectedScores.length) : 0;
          const mean = avg;
          formula = formula.replace(/addition/g, sum.toString())
                           .replace(/multiplication/g, product.toString())
                           .replace(/min/g, min.toString())
                           .replace(/max/g, max.toString())
                           .replace(/avg/g, avg.toString())
                           .replace(/mean/g, mean.toString());
          try {
            // eslint-disable-next-line no-eval
            calculatedScore = eval(formula);
          } catch {
            calculatedScore = 0;
          }
        } else {
          calculatedScore = 0;
        }
        break;
      default:
        calculatedScore = 0;
    }

    // Update form and internal state
    if (myForm) {
      myForm.get('scoreField').setValue(calculatedScore);
    }

    // Update scoreField_value, innerObj, scoreArray
    this.innerObj[index] = {
      "scoreLabel": val.scoreLabel,
      'name': selectedNames.join(','),
      'score': calculatedScore,
      is_multi_value: true,
    };
    this.scoreArray = this.innerObj;

    this.finalscore = calculatedScore;
    this.autosum();
  }
  autosum() {
    let riskValue = [];
    if (typeof this.scoreArray == 'object') {
      this.sum = 0;
      this.scoreArray.forEach((element) => {
        if (element?.score && !isNaN(element?.score)) {
          this.sum += Number(element.score);
        }
      });
    }
    if (this.isScoreData) {
      for (let i = 0; i < this.scoreData.length; i++) {
        riskValue.push(this.scoreData[i].riskLevel);
        if (this.scoreData[i].autoSumValue == 'greater_than') {
          if (this.sum > this.scoreData[i].range1) {
            console.log('condition 1 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'less_than') {
          if (this.sum < this.scoreData[i].range1) {
            console.log('condition 2 called');
            this.setDropDown(riskValue, i);
            break;
          }
        } else if (this.scoreData[i].autoSumValue == 'is_equal_to') {
          if (this.sum == this.scoreData[i].range1) {
            console.log('condition 3 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'greater_than_or_equal_to') {
          if (this.sum >= this.scoreData[i].range1) {
            console.log('condition 4 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'less_than_or_equal_to') {
          if (this.sum <= this.scoreData[i].range1) {
            console.log('condition 5 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'is_not_equal_to') {
          if (this.sum != this.scoreData[i].range1) {
            console.log('condition 6 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'is_between') {
          if (this.sum >= this.scoreData[i].range1 && this.sum <= this.scoreData[i].range2) {
            console.log('condition 7 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else if (this.scoreData[i].autoSumValue == 'is_not_between') {
          if (this.sum <= this.scoreData[i].range1 && this.sum >= this.scoreData[i].range2) {
            console.log('condition 8 called');
            this.setDropDown(riskValue, i);
            break;
          }
        }
        else {
          console.log('condition 9 called');
          // do nothing
        }
      }
    }
    // let scoreArray = this.scoreForm.value.rows;
    // this.valueAdded.emit({ "riskLevel": this.risk, "scoreSum": this.sum, "scoreField": this.scoreArray });

    let jsonValue = { "riskLevel": this.risk, "scoreSum": this.sum, "scoreField": this.scoreArray }
    let final_output = JSON.stringify(jsonValue);
    this.value = final_output;
  }
  setDropDown(riskValueArray, index) {
    // setting risk value
    let riskDropdown1 = this.elementRef.nativeElement.querySelector('#risk');
    riskDropdown1['value'] = riskValueArray[index];
    this.risk = riskValueArray[index];
  }

  onRiskValSelect(e) {
    this.risk = e.target.value;
    let jsonValue = { "riskLevel": this.risk, "scoreSum": this.sum, "scoreField": this.scoreArray }
    let final_output = JSON.stringify(jsonValue);
    this.value = final_output;
  }

  get getFormControls() {
    const control = this.scoreForm.get('rows') as FormArray;
    return control;
  }

  get getValues(): FormArray {
    return this.scoreForm.get('rows') as FormArray;
  }

  initiateForm(): FormGroup {
    return this.fb.group({
      scoreLabel: [''],
      score: [''],
      scoreSum: [''],
      scoreField: [''],
      scoreDisplayVal: [''],
      numeric_value: [''],
    });
  }

  addRow(fieldname: any, score?: any, data?: any, sum?: any, numeric_value?: any, is_multi_value?: boolean) {
    const control = this.scoreForm.get('rows') as FormArray;
    let formGroup = this.initiateForm();
    formGroup.controls['scoreLabel'].setValue(fieldname);
    if (score)
      formGroup.controls['scoreField'].setValue(score);
    if (data)
      formGroup.controls['score'].setValue(data);
    if (is_multi_value)
      formGroup.controls['score'].setValue(data.split(','));
    if (numeric_value)
      formGroup.controls['numeric_value'].setValue(numeric_value);
    control.push(formGroup);
  }
  getDivClass() {
    if (this.question.layout_type == "one-column") {
      this.className = "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";
    }
    else if (this.question.layout_type == "two-column") {
      this.className = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
    }
    else if (this.question.layout_type == "three-column") {
      this.className = "col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4";
    }
    else {
      this.className = "col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4";
    }
  }
}
